import { number, string } from 'yup';

export const mapTypeToValidationFn = (type?: string) => {
  if (type === 'number') {
    return number();
  }

  return string();
};
